module.exports = __webpack_public_path__ + "static/NeueEinstellungRegular-face89e129ef744a193467ff844d32a1.woff";